import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.css';
import './fonts/cabin-bold/fonts.css';
import './fonts/lato/fonts.css';
import './index.css';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';

import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './ui_refresh/App';
import { datadogRum } from '@datadog/browser-rum';
import { WhiteLabelProvider } from 'react-whitelabel';
import { store } from './store';
import { labels, whiteLabelBrand } from './whitelabel/resources';
import { returnString } from './ui_refresh/utils/environmentVariables';
import { BrowserRouter as Router } from 'react-router-dom';

ReactDOM.render(
  <WhiteLabelProvider labels={labels} selectedLabel={whiteLabelBrand}>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </WhiteLabelProvider>,
  document.getElementById('root')
);

datadogRum.init({
  applicationId: returnString(import.meta.env.VITE_DATADOG_APP_ID),
  clientToken: returnString(import.meta.env.VITE_DATADOG_CLIENT_TOKEN),
  site: 'datadoghq.com',
  service: returnString(import.meta.env.VITE_DATADOG_APP_NAME),
  env: returnString(import.meta.env.VITE_ENVIRONMENT),

  // Specify a version number to identify the deployed version of your application in Datadog
  version: returnString(import.meta.env.VITE_BUILD_VERSION, 'localhost'),
  sampleRate: 100,
  trackInteractions: true,
  allowedTracingOrigins: [/(https:|http:)*\/\/(localhost:5001|api\.(stage\.)*restoreskills.com)/],
});
